var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_128048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.305 10.9629C20.305 10.2831 20.2499 9.59966 20.1323 8.93091H10.7V12.7817H16.1014C15.8773 14.0237 15.1571 15.1223 14.1025 15.8205V18.3191H17.325C19.2173 16.5774 20.305 14.0053 20.305 10.9629Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6999 20.7332C13.397 20.7332 15.6714 19.8476 17.3286 18.3191L14.1061 15.8205C13.2096 16.4304 12.0521 16.7758 10.7036 16.7758C8.09474 16.7758 5.88272 15.0158 5.08904 12.6494H1.76367V15.2252C3.46127 18.602 6.91892 20.7332 10.6999 20.7332Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0854 12.6494C4.66651 11.4075 4.66651 10.0626 5.0854 8.82066V6.24487H1.7637C0.345367 9.07052 0.345367 12.3996 1.7637 15.2252L5.0854 12.6494Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6999 4.69059C12.1256 4.66855 13.5035 5.20502 14.536 6.18977L17.3911 3.33472C15.5833 1.63713 13.1838 0.703822 10.6999 0.733218C6.91892 0.733218 3.46126 2.8644 1.76367 6.24488L5.08537 8.82067C5.87537 6.45065 8.09106 4.69059 10.6999 4.69059Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_128048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.732544)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleImg);
export default __webpack_public_path__ + "static/media/google_img.f61045cdd4561519408a94e12d164233.svg";
export { ForwardRef as ReactComponent };